// \src\pages\home\components\FeaturedCategories.tsx

import { Link } from "react-router-dom";
import { useAdmin } from "@/context/AdminContext";

export default function FeaturedCategories() {
  const { data } = useAdmin();
  const categories = data.categories;

  return (
    <section className="w-full py-16 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-label font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-3">
            Explore nosso catálogo
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Principais Categorias
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Encontre tudo que precisa para sua construção ou reforma em um só lugar.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.slice(0, 8).map((cat) => (
            <Link
              key={cat.id}
              to={`/produtos?categoria=${cat.id}`}
              className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>

              <div className="p-3">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 flex items-center justify-center bg-primary-100 text-primary-600 rounded-md shrink-0">
                    <i className={`${cat.icon} text-sm`} />
                  </div>
                  <h3 className="font-label font-semibold text-foreground-900 text-sm leading-tight">
                    {cat.name}
                  </h3>
                </div>

                <p className="text-foreground-500 text-xs">
                  {cat.subcategories.length} subcategorias
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/produtos"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-md font-label font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            Ver Todos os Produtos
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}